import React from 'react';
import { Button } from '@/components/ui/button';
import { Locate } from 'lucide-react';

interface LocationButtonProps {
  onClick: () => void;
  className?: string;
}

const LocationButton: React.FC<LocationButtonProps> = ({ onClick, className = "" }) => {
  return (
    <Button
      onClick={onClick}
      className={`w-12 h-12 rounded-full shadow-lg bg-white/90 backdrop-blur-md hover:bg-white/95 border border-gray-300/50 z-50 transition-all duration-200 hover:scale-105 md:mb-0 mb-20 ${className}`}
      aria-label="Se localiser"
    >
      <Locate className="w-5 h-5 text-gray-700" />
    </Button>
  );
};

export default LocationButton;